'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../index-8844a274.js');
require('tslib');
require('react');
require('../lib-75591456.js');
require('../utils-eb39d0ac.js');
require('../env-100217af.js');
require('../definitions-4ae1604d.js');
require('@prisjakt/design-tokens/light-theme-colors');
require('../index-448c776e.js');
require('../style-inject.es-71b52b81.js');



exports.Clickable = index.Clickable;
//# sourceMappingURL=index.js.map
